export default {
    SWITCH_ENV: 'SWITCH_ENV',
};
